<template>
  <div class="container" ref="refSvgContainer">
    <svg-sedan v-if="body == 'SEDAN' || body == 'SUV'"
               :selectedSchemeParts="uniqueSelectedSchemeParts" />
    <svg-other v-else
               :selectedSchemeParts="uniqueSelectedSchemeParts" />
  </div>
</template>

<script>
import SvgOther from './svg-assessment/other.vue'
import SvgSedan from './svg-assessment/sedan.vue'

export default {
  name: 'svg-parts-viewer',
  components: {
    SvgOther,
    SvgSedan
  },
  props: {
    selectedSchemeParts: {
      type: Array,
      default: () => {
        return []
      }
    },
    body: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isBonnet: false,
    }
  },
  computed: {
    uniqueSelectedSchemeParts() {
      if (!Array.isArray(this.selectedSchemeParts)) return [];
      return [...new Set(this.selectedSchemeParts)];
    }
  },
  mounted() {

  },
  methods: {
    hideElem() {
      this.isBonnet = !this.isBonnet
    },
  },
}
</script>
